var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "form-group" }, [
      _c("label", [
        _vm._v(
          _vm._s(_vm.$t("productQualityTests.measurement.model.testerName"))
        )
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.measurement.testerName,
            expression: "measurement.testerName"
          }
        ],
        staticClass: "form-control mb-1",
        attrs: { type: "text", maxlength: "64" },
        domProps: { value: _vm.measurement.testerName },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.measurement, "testerName", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", [
        _vm._v(
          _vm._s(_vm.$t("productQualityTests.measurement.model.testComment"))
        )
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.measurement.testComment,
            expression: "measurement.testComment"
          }
        ],
        staticClass: "form-control mb-1",
        attrs: { type: "text", maxlength: "64" },
        domProps: { value: _vm.measurement.testComment },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.measurement, "testComment", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", [
        _vm._v(_vm._s(_vm.$t("productQualityTests.measurement.model.testDate")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.testDate,
            expression: "testDate"
          }
        ],
        staticClass: "form-control",
        attrs: { type: "datetime-local" },
        domProps: { value: _vm.testDate },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.testDate = $event.target.value
          }
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }